import * as React from 'react';
import styled from 'styled-components';
import { Text } from '../Text/Text';

const StyledModalWrapper = styled.div<{ visible }>`
  z-index: 9999999;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.background2};
`;

const ModalContainer = styled.div`
  width: 100%;
  max-height: 296px;
  max-width: 475px;
  background: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;
  padding: 78px 25px;
  align-items: center;
  justify-content: space-between;
`;

const ModalTitle = styled(Text)`
  font-family: Poppins;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0.18px;
  margin-bottom: 40px;
  display: inline;
  background: linear-gradient(
    0deg,
    ${({ theme }) => theme.colors.secondary} 50%,
    transparent 50%
  );
  user-select: none;
  text-align: center;
`;

const ModalDescription = styled(Text)`
  font-family: Poppins, 'Montserrat', sans-serif;
  width: 60%;
  font-weight: 500;
  font-size: 16px;
  line-height: 32px;
  text-align: center;
  letter-spacing: 0.18px;
  color: #373b40;
`;

export interface IUnsupportedScreenModalProps {
  visible?: boolean;
}

const UnsupportedScreenModal: React.FunctionComponent<IUnsupportedScreenModalProps> = ({
  visible
}) => {
  return (
    <StyledModalWrapper visible={visible}>
      <ModalContainer>
        <ModalTitle>This screen size is not supported yet.</ModalTitle>
        <ModalDescription>
          Please switch to your desktop or laptop to use Streda.
        </ModalDescription>
      </ModalContainer>
    </StyledModalWrapper>
  );
};

export default UnsupportedScreenModal;
